<template>
  <div
    class="flex w-full flex-col items-center space-y-10 md:space-y-14 xl:space-y-16"
  >
    <h2
      class="relative flex flex-col items-center text-center text-[72px] leading-[1.25em] md:text-[115px] lg:text-[101px]"
    >
      <span
        class="type-font-salt-ss02 mb-[0.3em] inline-block -rotate-1 font-medium"
        v-text="props.largeText"
      />
      <span class="type-heading-5 uppercase" v-text="`\n${smallText}`" />
      <div class="pointer-events-none absolute inset-0">
        <slot name="text-icons" />
      </div>
    </h2>
    <div
      class="relative mx-auto aspect-[4/3] w-full max-w-lg lg:max-w-2xl xl:max-w-4xl"
    >
      <div class="image h-full w-full overflow-hidden rounded-xl">
        <PayloadImage
          class="h-full w-full object-cover"
          :image="props.image"
          :sizes="{
            default: '90vw',
            md: '512px',
            lg: '672px',
            xl: '896px',
          }"
        />
      </div>
      <div class="pointer-events-none absolute inset-0">
        <slot name="image-icons" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Image } from '#payload/types'

interface AboutCarouselSlideProps {
  image: string | Image
  largeText: string
  smallText: string
}

const props = defineProps<AboutCarouselSlideProps>()
</script>
